import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as i0 from "@angular/core";
import * as i1 from "ngx-device-detector";
var DraftAccessGuard = /** @class */ (function () {
    function DraftAccessGuard(deviceService) {
        this.deviceService = deviceService;
    }
    DraftAccessGuard.prototype.canActivate = function (route, state) {
        var userId = null;
        try {
            var currentUserStr = localStorage.getItem('currentUser');
            if (currentUserStr) {
                var currentUser = JSON.parse(currentUserStr);
                userId = currentUser.id;
            }
        }
        catch (e) {
            console.error('Error parsing currentUser from localStorage', e);
        }
        var isDivisibleBy3 = userId && !isNaN(Number(userId)) && Number(userId) % 3 === 0;
        var isAndroidMobile = this.deviceService.isMobile() && this.deviceService.os === 'Android';
        if (!isAndroidMobile && !isDivisibleBy3) {
            var currentPath = state.url.startsWith('/') ? state.url : '/' + state.url;
            var redirectUrl = environment.SITE_URL + "/draftsv2" + currentPath;
            window.location.href = redirectUrl;
            return false;
        }
        return true;
    };
    DraftAccessGuard.ngInjectableDef = i0.defineInjectable({ factory: function DraftAccessGuard_Factory() { return new DraftAccessGuard(i0.inject(i1.DeviceDetectorService)); }, token: DraftAccessGuard, providedIn: "root" });
    return DraftAccessGuard;
}());
export { DraftAccessGuard };
